import React, { useEffect, useState } from 'react';
import BackToTop from '../../components/elements/BackToTop';
import Footer from '../../components/Layout/Footer';
import CarteleraMain from './CarteleraMain';
import HeaderStyleOne from '../../components/Layout/Header/HeaderStyleOne';


// Breadcrumbs Background Image

const Cartelera = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
        <HeaderStyleOne />
        <CarteleraMain/>
        <BackToTop scroll={isVisible} />
        <Footer />
    </React.Fragment>
    );
}

export default Cartelera;